import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#595959",
  "fill-rule": "evenodd",
  d: "M4.173 5.667a2.012 2.012 0 0 0-2.007 2.006v4.487c0 1.104.903 2.007 2.007 2.007h7.653a2.012 2.012 0 0 0 2.007-2.007v-.293h-.767c-.94 0-1.851-.688-1.938-1.703a1.839 1.839 0 0 1 .545-1.484 1.829 1.829 0 0 1 1.313-.547h.847v-.46a2.012 2.012 0 0 0-2.007-2.006H4.173ZM1.166 7.673a3.012 3.012 0 0 1 3.007-3.006h7.653a3.012 3.012 0 0 1 3.007 3.006v.96a.5.5 0 0 1-.5.5h-1.347c-.239 0-.45.093-.601.25l-.01.008a.839.839 0 0 0-.25.681v.006c.035.424.442.789.941.789h1.267a.5.5 0 0 1 .5.5v.793a3.012 3.012 0 0 1-3.007 3.007H4.173a3.012 3.012 0 0 1-3.007-3.007V7.673Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#595959",
  "fill-rule": "evenodd",
  d: "M9.4 2.633a.767.767 0 0 0-1.036-.719l-5.294 2a1.399 1.399 0 0 0-.904 1.313v3.046a.5.5 0 0 1-1 0V5.227c0-1 .615-1.894 1.55-2.248l5.293-2a1.767 1.767 0 0 1 2.39 1.654v2.534a.5.5 0 1 1-1 0V2.633ZM12.986 9.133c-.239 0-.45.093-.601.25l-.01.008a.839.839 0 0 0-.25.681v.006c.035.424.442.789.941.789h1.295a.184.184 0 0 0 .179-.18V9.313a.184.184 0 0 0-.178-.18h-1.376Zm-1.314-.453a1.829 1.829 0 0 1 1.314-.547h1.405a1.184 1.184 0 0 1 1.149 1.18v1.374a1.184 1.184 0 0 1-1.167 1.18h-1.307c-.94 0-1.851-.688-1.938-1.703a1.84 1.84 0 0 1 .544-1.484Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#595959",
  "fill-rule": "evenodd",
  d: "M4.166 8a.5.5 0 0 1 .5-.5h4.667a.5.5 0 0 1 0 1H4.666a.5.5 0 0 1-.5-.5Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}
export default { render: render }